import { useState } from "react";
import Image from "next/image";
import { Gallery } from "../../gallery";
import Modal from "react-modal";
import { formatProductsImages, truncate } from "helpers";
import Link from "next/link";
import SmallProductThumbnail from "components/customImages/SmallProductThumbnail";
import { useTranslation } from "next-i18next";
import StoreLogo from "components/customImages/StoreLogo";
import affarIndc from "public/images/affar_indc.svg";
const customStyles = {
  content: {
    // top: '50%',
    // left: '50%',
    // right: 'auto',
    // bottom: 'auto',
    // marginRight: '-50%',
    // transform: 'translate(-50%, -50%)',
    // width: '90%',
    // height: '100vh'
    overflowY: "hidden",
  },
  // modal:{
  //   width : '90px'
  // },
  overlay: {
    zIndex: "99999999",
  },
};

const SellerPageCard = ({ storeData, category, lang, haveAffar = false }) => {
  const { t: translate } = useTranslation("categories");

  const productImages = formatProductsImages(storeData.attributes.productImageNames);
  const data = {
    pageImg: productImages[0].image.bigProductThumbCard,
    avatar: storeData.attributes.mainImage.data.attributes.url,
    imageName: storeData.attributes.mainImage.data.attributes.url.split("/").pop(),
    title: storeData.attributes.name,
    stars: storeData.attributes.reviewRate?.split("_")[1],
    likes:
      storeData.attributes.likesNbr >= 1000000
        ? "+1M"
        : storeData.attributes.likesNbr >= 100000
          ? "+100K"
          : storeData.attributes.likesNbr >= 10000
            ? "+10K"
            : storeData.attributes.likesNbr >= 1000
              ? "+1K"
              : "<1K",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Molestiae eligendi fugit pariatur necessitatibus.",
    products: productImages,
    activity: storeData.attributes.platformActivity,
    responseReaction: storeData.attributes.responseReaction,
    social: storeData.attributes.platform,
    hasDelivery: storeData.attributes.hasDelivery ? "Oui" : "Non",
    url: storeData.attributes.url,
    category: storeData?.attributes?.sub_category?.data?.attributes?.name?.split(" > ")[1],
    id: storeData?.id,
    slug: storeData.attributes.slug,
  };

  const [productsDisplay, setProductsDisplay] = useState(false);

  const addHttp = (url: string): string => {
    const hasHttp = url.search("http");
    if (hasHttp !== -1) {
      return url;
    }
    return ["https://", url].join("");
  };

  const convert = (word: string, lang: string): string => {
    const RESERVED_WORDS = {
      MEDIUM: { fr: "Moyenne", ar: "عادي" },
      FAST: { fr: "Rapide", ar: "سريع" },
      HIGH: { fr: "Fréquente", ar: "متكرر" },
      LOW: { fr: "Faible", ar: "ضعيف" },
      SLOW: { fr: "Lente", ar: "بطيء" },
      Oui: { fr: "Oui", ar: "نعم" },
      Non: { fr: "Non", ar: "لا" },
      null: { fr: "Anonyme", ar: "مجهول" },
    };
    return RESERVED_WORDS?.[word]?.[lang] || word;
  };
  return (
    <div className="my-element lg:w-80 h-90 bg-[#F9F9F9] md:px-4 pt-2 pb-4 rounded-md cursor-pointer relative">
      {haveAffar && (
        <div className="absolute z-10  top-[10%] rtl:right-0 ltr:left-0 ">
          <Image src={affarIndc} alt="affar_indc" className="rtl:rotate-180" />
          <span className="absolute ltr:bottom-[40%] rtl:top-[30%] rtl:right-5 ltr:left-5 text-white font-bold leading-5 text-base  tracking-wider">
            {translate("affar")}
          </span>
        </div>
      )}

      <div
        style={{ backgroundImage: `url(${data?.pageImg})` }}
        className=" h-[85%] border border-backgroundGrey rounded-lg bg-white overflow-hidden bg-cover bg-center drop-shadow-md"
        aria-label={`${data?.title}`}
      >
        <Link
          href={{
            pathname: "/categories/[category]/[id]",
            query: { category, id: data.slug },
          }}
          passHref
        >
          <div className="flex justify-between h-[270px] m-2"></div>
        </Link>
        <button
          dir="ltr"
          className="flex w-[95%] h-[20%] bg-[#D9D9D945] mt-4 m-auto -space-x-5 justify-center rounded-md"
          onClick={() => setProductsDisplay(!productsDisplay)}
        >
          {data.products.slice(0, 6).map((product, index) =>
            product.image?.smallProductThumbnailUrl ? (
              <div className="flex self-center rounded-full" key={`_product_index_${index}`}>
                <div key={`product_index_${index}`}>
                  <SmallProductThumbnail imageName={product.image.name} alt={data.title} />
                </div>
              </div>
            ) : (
              <p key={`_product_index_${index}`}> </p>
            ),
          )}
        </button>
      </div>
      <div dir="ltr" className="flex items-center mt-2 rtl:flex-row-reverse">
        <div className="flex rtl:flex-row-reverse">
          <div className="self-center w-16 h-16 fill relative ltr:mr-2 rtl:ml-2 ltr:ml-2 rtl:mr-2">
            <StoreLogo imageName={data.imageName} alt="micro-icon" />
            <div className="w-5 h-5 rounded-full absolute bottom-0 right-1 bg-white p-[2.5px]">
              <Image
                className="rounded-full"
                src={`/images/micro-icon-${data.social?.toLowerCase()}.svg`}
                alt="delivery truck logo"
                width={17}
                height={17}
              />
            </div>
          </div>
          <div className="flex flex-col justify-center items-center">
            <Link
              href={{
                pathname: "/categories/[category]/[id]",
                query: { category, id: data.slug },
              }}
              passHref
            >
              <div className="text-start hover:underline">{truncate(data.title)}</div>
            </Link>
            <div className="flex justify-center items-center gap-2 rtl:flex-row-reverse">
              <div className="mb-2 opacity-90 flex bg-[#F9F9F9] gap-x-1 rtl:flex-row-reverse">
                {data.stars && (
                  <>
                    <Image src="/images/star.svg" alt="star image" width={20} height={20} />
                    <figcaption className="text-xs self-center">{data.stars || 0}</figcaption>
                  </>
                )}
              </div>
              {data.stars && <div className="border-r-2 text-[#F9F9F9]">.</div>}
              <div className="my-2 opacity-90 flex -mt-px bg-[#F9F9F9] gap-x-1 rtl:flex-row-reverse">
                <Image src="/images/thup.svg" alt="thumbs up logo" width={20} height={20} />
                <figcaption className="text-xs self-center">{data.likes}</figcaption>
              </div>
              <div className="border-r-2 text-[#F9F9F9]">.</div>
              <div className="my-2 opacity-90 flex -mt-px bg-[#F9F9F9] gap-x-1 rtl:flex-row-reverse">
                <Image src="/images/truck.svg" alt="delivery truck logo" width={20} height={20} />
                <figcaption className="text-xs self-center">
                  {convert(data.hasDelivery, lang)}
                </figcaption>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        ariaHideApp={false}
        isOpen={productsDisplay}
        onRequestClose={() => setProductsDisplay(false)}
        style={customStyles}
        contentLabel="Example Modal"
        onAfterOpen={() => {
          if (document) {
            document.body.style.overflow = "hidden";
          }
        }}
        onAfterClose={() => {
          if (document) {
            document.body.style.overflow = "visible";
          }
        }}
      >
        <Gallery styleClass={"seller-container"} products={data.products} />
      </Modal>
    </div>
  );
};

export default SellerPageCard;
